import * as React from 'react';

const SvgCookmode: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={25}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.056 3H3.008c-1.113 0-2.005.89-2.005 2v12c0 1.1.892 2 2.005 2h5.013v2h8.022v-2h5.013a2 2 0 001.995-2l.01-12c0-1.11-.902-2-2.005-2zm0 14H3.008V5h18.048v12zM9.024 15l7.019-4-7.019-4v8z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgCookmode;
